import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { APPLICATIONS } from '../data/products';
import Breadcrumbs from '../components/Breadcrumbs';
import ChapterBreak from '../components/ChapterBreak';
import { Reveal } from '../components/Reveal';

const HERO_IMG = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_modularoom-design/artifacts/sohjvoio_Gemini%20SS32%201%281%29.webp';

const KEYS = ['weekend-homes','farmhouses'];

export default function Residential() {
  const items = APPLICATIONS.filter((a) => KEYS.includes(a.id));
  return (
    <main data-testid="residential-page" className="bg-white text-[#111]">
      <Helmet>
        <title>Residential Solutions | MODULAROOM</title>
        <meta name="description" content="Luxury modular homes for weekend retreats, farmhouses and family residences. Prefab homes and prefabricated cottages built off-site and delivered as a complete architectural product." />
        <link rel="canonical" href="https://modularoom.com/residential" />
      </Helmet>
      <section className="pt-40 md:pt-56 pb-16 max-w-[1440px] mx-auto px-6 md:px-12">
        <Breadcrumbs items={[{label:'Home', to:'/'}, {label:'Applications'}, {label:'Residential'}]} />
        <h1 className="mt-14 font-display text-6xl md:text-7xl lg:text-8xl tracking-tight leading-[0.95] max-w-5xl">
          A modern residence,<br/><span className="italic text-black/40">delivered.</span>
        </h1>
        <p className="mt-10 max-w-xl text-[17px] text-black/60 leading-[1.75]">
          Purpose-built spaces for modern residential life. From private weekend retreats and farmhouses to premium prefab homes designed for long stays.
        </p>
      </section>

      <ChapterBreak src={HERO_IMG} chapter="Residential" minHeight="60svh" />

      <section className="pb-32">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-x-10 md:gap-x-16 gap-y-24">
          {items.map((a, i) => {
            const anchor = a.id.startsWith('holiday') ? 'holiday' : a.id.startsWith('weekend') ? 'weekend' : a.id.split('-')[0];
            return (
              <Reveal key={a.id}>
                <div id={anchor} className="group">
                  <div className="relative aspect-[4/5] overflow-hidden">
                    <img src={a.image} alt={a.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-[1.045]" />
                    <div className="absolute top-5 left-5 text-[10px] tracking-[0.28em] uppercase text-white/90">/{String(i+1).padStart(2,'0')}</div>
                  </div>
                  <div className="mt-6 font-display text-3xl md:text-4xl tracking-tight">{a.title}</div>
                  <div className="mt-3 text-black/65 leading-relaxed max-w-md">{a.caption}</div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </main>
  );
}
